import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, ScanLine, TreePine, Leaf, ShoppingCart } from "lucide-react";

const tabs = [
  { path: "/", icon: Home, label: "Home" },
  { path: "/identify", icon: ScanLine, label: "Identify" },
  { path: "/yard-plan", icon: TreePine, label: "Yard Plan" },
  { path: "/my-plants", icon: Leaf, label: "My Plants" },
  { path: "/shopping-list", icon: ShoppingCart, label: "List" },
];

export default function BottomNav({ currentPath }) {
  const navigate = useNavigate();

  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl bg-white border-t-2 border-[#0A2918] z-50 pb-safe no-print"
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around h-20">
        {tabs.map((tab) => {
          const isActive = currentPath === tab.path;
          const Icon = tab.icon;
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              data-testid={`nav-${tab.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`flex flex-col items-center justify-center gap-1 flex-1 h-full transition-colors duration-200 ${
                isActive
                  ? "text-[#E25F45]"
                  : "text-[#0A2918]"
              }`}
            >
              <Icon
                size={28}
                strokeWidth={isActive ? 3 : 2.5}
              />
              <span className={`text-xs font-bold tracking-wide ${isActive ? "text-[#E25F45]" : ""}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
